let reviewSwiper;

function initReviewSwiper() {
  const isDesktop = window.innerWidth > 1024;

  if (reviewSwiper) reviewSwiper.destroy(true, true);

  reviewSwiper = new Swiper('.review__swiper', {
    effect: isDesktop ? 'cards' : 'slide',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: isDesktop ? 1 : 1.3,
    spaceBetween: isDesktop ? 0 : 10,
    navigation: isDesktop
      ? {
          nextEl: '.review-swiper-button-next',
          prevEl: '.review-swiper-button-prev'
        }
      : false,
    pagination: !isDesktop
      ? {
          el: '.review-swiper-pagination',
          clickable: true
        }
      : false,
    cardsEffect: isDesktop
      ? {
          rotate: true,
          perSlideRotate: 1,
          perSlideOffset: 1,
          slideShadows: false
        }
      : {},
    on: {
      setTranslate(swiper) {
        swiper.slides.forEach((slide) => {
          // Remove Z-depth shrinking
          slide.style.transform = slide.style.transform.replace(
            /translate3d\(([^,]+),\s*([^,]+),\s*[^)]+\)/,
            'translate3d($1, $2, 0px)'
          );
        });
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initReviewSwiper);

let reviewResizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(reviewResizeTimeout);
  reviewResizeTimeout = setTimeout(initReviewSwiper, 300);
});
